import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UidGenerator {
  // TODO: we could use crypto.randomUUID() if we use a later version of node
  public static generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public static createGuid(length = 10): string {
    const allowedValues = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let guid = '';
    for (let i = 0; i < length; i++) {
      const index = Math.floor(Math.random() * allowedValues.length);
      guid += allowedValues[index];
    }
    return guid;
  }
}
